export enum SocketAuthPatterns {
  REFRESH = 'refresh_token',
}

export enum SocketPresentationsPatterns {
  PRESENTATION_CREATED = 'presentation_created',
  PRESENTATION_UPDATED = 'presentation_updated',
}

export enum SocketEditorPatterns {
  ROLE_ASSIGNED = 'role_assigned',
  NEW_EDITOR = 'new_editor',
}

export enum SocketEditorRoles {
  EDITOR = 'editor',
  READER = 'reader',
}

export type roleData = { role: SocketEditorRoles; editor_name: string }
